module.exports = __webpack_public_path__ + "img/21.8285ff49.png";